import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  x: "6",
  y: "6",
  width: "7",
  height: "6.667",
  rx: "2",
  stroke: "#1F1F1F"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  x: "15",
  y: "6",
  width: "7",
  height: "6.667",
  rx: "2",
  stroke: "#1F1F1F"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("rect", {
  x: "6",
  y: "15.333",
  width: "7",
  height: "6.667",
  rx: "2",
  stroke: "#1F1F1F"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("rect", {
  x: "15",
  y: "15.333",
  width: "7",
  height: "6.667",
  rx: "2",
  stroke: "#1F1F1F"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}
export default { render: render }